export default "https://assets-v2.scaler.com/packs/images/thumbs-up.7104b0.svg";